import CityPageTemplate from "../city-template/CityPageTemplate";
import { oceansideConfig } from "./data";

export default function OceansidePage() {
  return <CityPageTemplate config={oceansideConfig} />;
}